module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/europe.png?1c303efed400200b700c0f253117062a";